module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread1.baeac9cf.jpg";